import { render, staticRenderFns } from "./DetailsStep.vue?vue&type=template&id=673b07fa&scoped=true"
import script from "./DetailsStep.vue?vue&type=script&lang=js"
export * from "./DetailsStep.vue?vue&type=script&lang=js"
import style0 from "./DetailsStep.vue?vue&type=style&index=0&id=673b07fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b07fa",
  null
  
)

export default component.exports